export const authRoutesNames = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  REFRESH: 'refresh',
  REGISTER: 'register',
  VERIFY: 'verify/:uuid',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password/:uuid',
};
